import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PagesEndpoints } from '@shared/enums/pages-endpoints.enum';
import { HomesService } from '@shared/services/homes.service';

@Component({
  selector: 'im-callback',
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss',
})
export class CallBackComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  private readonly homesService = inject(HomesService);
  constructor() {
    this.router.navigateByUrl(
      `/private/${this.homesService.currentVisitedHome$.value?.name}/${PagesEndpoints.Mandates}`,
    );
  }
}
